module.exports = __webpack_public_path__ + "img/postgresql.b298181f.svg";